<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text=" ($route.params.id ? '编辑' : '添加')+'基地'"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="文章标题" prop="title">
              <Input disabled="disabled" class="perW60" v-model="infoData.title"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="封面图" prop="cover">
              <img :src="infoData.cover" style="width: 50px;height: 50px;" alt="封面图">
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="文章类型" prop="type_msg">
              <Input disabled="disabled" class="perW30" v-model="infoData.type_msg"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="推荐状态" prop="recommend_status_msg">
              <Input disabled="disabled" class="perW30" v-model="infoData.recommend_status_msg"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="文章内容" prop="contents">
              <div style="border: 1px solid #e9e9e9;border-radius: 10px;padding: 10px;">
                <div v-html="infoData.contents"></div>
              </div>
            </FormItem>
          </Col>

        </Row>
      </Form>
    </card>

  </div>
</template>
<script>
import {baseArticleInfoApi} from '@/api/baseArticle/baseArticle'

export default {
  name: 'baseArticleInfo',
  data() {
    return {
      infoData: {
        base_article_id: 0,
        title: '',
        cover: '',
        type_msg: '',
        recommend_status_msg: '',
        contents: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {

    // 加载数据
    loadInfoData(id) {
      baseArticleInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
